import { render, staticRenderFns } from "./LeftBox.vue?vue&type=template&id=a9af79e0&"
import script from "./LeftBox.vue?vue&type=script&lang=ts&"
export * from "./LeftBox.vue?vue&type=script&lang=ts&"
import style0 from "./LeftBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports